import React, { useEffect, useState, useRef } from "react";
import Top_navbar from "../../DashBaord/Top_navbar";
import { ASSETS_BASE_URL } from "../../../config/constants";
import { FaPlusSquare } from "react-icons/fa";
import { Select, Typography } from "antd";
import { TbCategory } from "react-icons/tb";
import { notification } from "antd";
import { Box } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PropTypes from "prop-types";
import moment from "moment";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { addEditData } from "../../../controllers/cms/emailTemplets";
import { Link, useLocation, useNavigate } from "react-router-dom";

function CategoriesProductList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CategoriesProductList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Treats() {
  /********************** Integratin Stare Here **********************/
  const targetRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [GETDATA, SETGETDATA] = useState(state ? state : []);
  const [DESCRIPTION, setDescription] = useState(GETDATA?.templet || '');
  const [errors, setErrors] = useState("");
  // console.log('ADDEDITDATA',ADDEDITDATA);
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    if(GETDATA?._id){
      form.append('editId',GETDATA?._id);
    }
    form.append('templet',DESCRIPTION);
    const rawData = {};
    const isValidate = await validateFormData(form);
    if(isValidate){
      form.forEach((value, key) => {
        rawData[key] = value;
      });
      const res = await addEditData(rawData);
      if(res.status === true){
        notification.open({
          message: "Success",
          description: " Data save Successfully.",
          placement: "topRight",
          icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
        SETGETDATA('');
        setDescription();
        navigate('/cms/email-templates');
      }else{
        notification.open({
          message: "Error",
          description: res?.message || "Please try after some time",
          placement: "topRight",
          icon: <CheckCircleTwoTone twoToneColor="red" />,
        });
      }
    }
  };

  const validateFormData = async (formData) => {
    try {
      if (
        formData.get("type") === "undefined" ||
        formData.get("type") === null ||
        formData.get("type").trim() === ""
      ) {
        setErrors((preError) => ({
          ...preError,
          type: "Name is required",
        }));
        return false;
       } else if (
          formData.get("subject") === "undefined" ||
          formData.get("subject") === null ||
          formData.get("subject").trim() === ""
        ) {
          setErrors((preError) => ({
            ...preError,
            subject: "Name is required",
          }));
          return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  };

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      SETGETDATA((pre) => ({
        ...pre,
        [name]: value,
      }));
    } catch (error) {}
  };
  useEffect(()=>{
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  },[])
  /********************** Integratin End Here **********************/
  return (
    <div className="container-fluid" ref={targetRef}>
      <Top_navbar title={`${GETDATA?._id?'Edit':'Add'} Email Template`}></Top_navbar>
      <div className="inventory_tabs_main_div">
        <Box sx={{ width: "100%" }}>
          <div>
            <div id="content-wrapper" className="d-flex flex-column">
              <div className="card shadow mb-4">
                <div className="card-body pt-0">
                  <div className="table-responsive term_and_condation_main_section">
                    <form method="post"  onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <label for="type" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Type</label>
                          <select className="form-control categories_select_tg_enter_product" name='type' id='type'>
                            <option value='' >Select Type</option>
                            <option value='order_success' selected={GETDATA?.type === 'order_success'?true:false}>Order Success</option>
                          </select>
                          {errors.type ? ( <p style={{ color: "red" }}> {errors.type} </p> ) : ( "" )}
                        </div>

                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <label for="subject" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Subject </label>
                          <input
                            type="text"
                            name="subject"
                            id="subject"
                            value={GETDATA?.subject}
                            className="form-control categories_select_tg_enter_product"
                            onChange={handleChange}
                          />
                          {errors.subject ? ( <p style={{ color: "red" }}> {errors.subject} </p> ) : ( "" )}
                        </div>

                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <label
                            for="title"
                            className="categories_open_popup_label_name all_lebel_margin_top_main_div"
                          >
                            Message{" "}
                          </label>
                        </div>
                        <div className="term_and_condation_react_quilllll">
                          <ReactQuill
                            theme="snow"
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, 4, 5, false] }],
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [
                                  { list: "ordered" },
                                  { list: "bullet" },
                                  { indent: "-1" },
                                  { indent: "+1" },
                                ],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                            formats={[
                              "header",
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                              "indent",
                              "link",
                              "image",
                            ]}
                            value={DESCRIPTION || ""}
                            onChange={setDescription}
                          />
                        </div>
                            <br/>
                        <div>
                          <button type="submit" class="btn btn-danger all_save_btn_btn_btn" >
                            <span className="request_new_categories"> {GETDATA?._id?'Save Changes':'Create'}</span>
                          </button> 
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
}
